<script setup>
// Example Vue SFC — a coloured DaisyUI status badge. Mounted via the `vue`
// Stimulus controller, e.g. in app/views/projects/show.html.erb.
defineProps({
  status: { type: String, required: true },
})

const COLORS = {
  active: "badge-success",
  inactive: "badge-ghost",
  pending: "badge-warning",
  archived: "badge-error",
}
</script>

<template>
  <span class="badge badge-sm" :class="COLORS[status] || 'badge-ghost'">{{ status }}</span>
</template>
